import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { TextArea } from '../../../../components/workbook/forms';

export default function Worksheet4_2Page() {
  const [topQuestion, setTopQuestion] = useState('');
  const [insights, setInsights] = useState('');

  return (
    <div className="min-h-screen bg-[var(--bg-raised)]">
      <header className="bg-[var(--mustard-dim)] border-b border-[var(--mustard)]">
        <div className="max-w-4xl mx-auto px-6 py-4">
          <Link
            to="/elevation/workbook/oqf/module-4"
            className="text-[var(--mustard)] hover:text-[var(--mustard)] text-sm mb-2 inline-flex items-center gap-1"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Module 4
          </Link>
          <h1 className="text-2xl font-bold text-[var(--text-pri)]">
            ✍️ Activity: Worksheet 4.2
          </h1>
        </div>
      </header>

      <div className="max-w-4xl mx-auto px-6 py-8">
        <div className="bg-[var(--surface)] p-6 mb-6">
          <h2 className="text-lg font-semibold text-[var(--text-pri)] mb-3">
            Instructions
          </h2>
          <p className="text-[var(--text-sec)]">
            Look at your completed rankings on the previous page. Now, answer these reflection questions.
          </p>
        </div>

        <div className="bg-[var(--bg-raised)] border border-[var(--rule)] p-6 mb-6 space-y-6">
          <div>
            <TextArea
              label="Based on your ranking, what is your #1 highest-leverage question? (The one with the highest 'Leverage' score)"
              value={topQuestion}
              onChange={(e) => setTopQuestion(e.target.value)}
              placeholder="Enter the top-ranked question..."
              rows={3}
            />
          </div>

          <div>
            <TextArea
              label="What key insight does this ranking give you? (e.g., What should the team do *first* on Monday morning? Were you surprised? What did this clarify?)"
              value={insights}
              onChange={(e) => setInsights(e.target.value)}
              placeholder="Share your insights and reflections..."
              rows={6}
            />
          </div>
        </div>

        <div className="bg-[var(--green-dim)] border border-[var(--green)] p-4 mb-6">
          <h3 className="font-semibold text-[var(--green)] dark:text-[var(--text-ter)] mb-2">💡 Key Insight</h3>
          <p className="text-sm text-[var(--green)] dark:text-[var(--text-ter)]">
            The "Delivery Risk" question (Q4) typically ranks #1 because it has an Effort of '1'—it's the <em>easiest</em> question to answer <em>and</em> one of the highest leverage. You should answer that <strong>this afternoon</strong> in one meeting, while you set up the <em>harder</em> (Effort=3) SDE for the 'Value Signal' question.
          </p>
        </div>

        <div className="flex justify-between items-center">
          <Link
            to="/elevation/workbook/oqf/module-4/worksheet-4-1"
            className="px-4 py-2 border border-[var(--rule)] text-[var(--text-sec)] hover:bg-[var(--surface)] inline-flex items-center gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Previous
          </Link>
          <Link
            to="/elevation/workbook/oqf/module-5"
            className="px-4 py-2 bg-[var(--mustard)] text-white hover:bg-[var(--mustard)] inline-flex items-center gap-2"
          >
            Next: Module 5
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </div>
  );
}






